/**
 * PortfolioListing - Search, Filter, Sort, and Expand functionality
 * Exact copy from Astro component
 */
(function() {
  // Elements
  const searchInput = document.getElementById('portfolio-search-input');
  const tableBody = document.getElementById('portfolio-table-body');
  const emptyState = document.getElementById('portfolio-empty-state');
  const clearSearchBtn = document.getElementById('portfolio-clear-search');
  const searchClearIcon = document.getElementById('portfolio-search-clear');
  const sortableHeaders = document.querySelectorAll('.sortable[data-sort]');

  // Sector filter elements
  const sectorFilter = document.getElementById('sector-filter');
  const sectorTrigger = document.getElementById('sector-filter-trigger');
  const sectorDropdown = document.getElementById('sector-filter-dropdown');
  const sectorBadge = document.getElementById('sector-filter-badge');
  const sectorClear = document.getElementById('sector-filter-clear');
  const sectorText = document.getElementById('sector-filter-text');
  const sectorOptions = document.querySelectorAll('.sector-option');

  // State
  let currentSort = null;
  // Use array to maintain selection order
  let selectedSectors = [];

  // Normalize sector string for comparison (handles &nbsp; → \u00A0, extra whitespace, etc.)
  function normalizeSector(s) {
    return s.replace(/[\u00A0\u200B\uFEFF\u2009\u2002\u2003]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  // Get all rows (refreshed after sort)
  function getRows() {
    return Array.from(document.querySelectorAll('.portfolio-row-wrapper'));
  }

  // Update last visible row for border styling
  function updateLastVisibleRow() {
    const rows = getRows();
    // Remove class from all rows
    rows.forEach(row => row.classList.remove('last-visible'));
    // Find and mark last visible row
    for (let i = rows.length - 1; i >= 0; i--) {
      if (rows[i].style.display !== 'none') {
        rows[i].classList.add('last-visible');
        break;
      }
    }
  }

  // Combined filter function (search + sector filter)
  function applyFilters() {
    const searchTerm = searchInput?.value.toLowerCase().trim() || '';
    let visibleCount = 0;

    getRows().forEach((row) => {
      const searchData = row.getAttribute('data-search') || '';
      const sector = normalizeSector(row.getAttribute('data-sector') || '');

      const matchesSearch = searchTerm === '' || searchData.includes(searchTerm);
      const matchesSector = selectedSectors.length === 0 || selectedSectors.some(s => normalizeSector(s) === sector);

      if (matchesSearch && matchesSector) {
        row.style.display = '';
        visibleCount++;
      } else {
        row.style.display = 'none';
        row.setAttribute('data-expanded', 'false');
      }
    });

    updateLastVisibleRow();

    // Update empty state
    if (visibleCount === 0 && (searchTerm !== '' || selectedSectors.length > 0)) {
      emptyState?.classList.remove('hidden');
      tableBody?.classList.add('hidden');
    } else {
      emptyState?.classList.add('hidden');
      tableBody?.classList.remove('hidden');
    }
  }

  // Sort functionality
  function sortTable(column) {
    const rows = getRows();
    if (!tableBody || rows.length === 0) return;

    // Determine sort direction
    let direction = 'asc';
    if (currentSort?.column === column && currentSort.direction === 'asc') {
      direction = 'desc';
    }

    // Sort rows
    const sortedRows = rows.sort((a, b) => {
      let aVal = a.getAttribute(`data-${column}`) || '';
      let bVal = b.getAttribute(`data-${column}`) || '';

      // Handle numeric sorting for weight
      if (column === 'weight') {
        const aNum = parseFloat(aVal) || 0;
        const bNum = parseFloat(bVal) || 0;
        return direction === 'asc' ? aNum - bNum : bNum - aNum;
      }

      // String sorting for other columns
      if (direction === 'asc') {
        return aVal.localeCompare(bVal);
      } else {
        return bVal.localeCompare(aVal);
      }
    });

    // Re-append sorted rows
    sortedRows.forEach(row => tableBody.appendChild(row));

    // Update state
    currentSort = { column, direction };

    // Update header visual state
    updateSortIndicators(column, direction);
  }

  function updateSortIndicators(activeColumn, direction) {
    sortableHeaders.forEach(header => {
      const column = header.getAttribute('data-sort');

      // Remove active state from all
      header.classList.remove('sort-asc', 'sort-desc');

      // Add active state to current column
      if (column === activeColumn) {
        header.classList.add(`sort-${direction}`);
      }
    });
  }

  // Event Listeners

  // Toggle clear icon visibility
  function updateClearIcon() {
    if (searchInput && searchClearIcon) {
      if (searchInput.value.length > 0) {
        searchClearIcon.classList.remove('hidden');
      } else {
        searchClearIcon.classList.add('hidden');
      }
    }
  }

  // Search input with debounce
  let debounceTimer;
  searchInput?.addEventListener('input', (e) => {
    updateClearIcon();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      applyFilters();
    }, 200);
  });

  // Clear search button (in empty state)
  clearSearchBtn?.addEventListener('click', () => {
    if (searchInput) {
      searchInput.value = '';
    }
    // Also clear sector filter
    selectedSectors = [];
    sectorOptions.forEach(option => {
      option.querySelector('.sector-check')?.classList.add('hidden');
      option.classList.remove('selected');
    });
    updateSectorUI();
    applyFilters();
    updateClearIcon();
    searchInput?.focus();
  });

  // Clear search icon (in input field)
  searchClearIcon?.addEventListener('click', () => {
    if (searchInput) {
      searchInput.value = '';
      applyFilters();
      updateClearIcon();
      searchInput.focus();
    }
  });

  // Sort headers
  sortableHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const column = header.getAttribute('data-sort');
      if (column) sortTable(column);
    });
  });

  // Expand/collapse functionality
  document.querySelectorAll('.portfolio-row').forEach(row => {
    row.addEventListener('click', (e) => {
      if (e.target.closest('a')) return;
      if (e.target.closest('.sortable')) return;

      const wrapper = row.closest('.portfolio-row-wrapper');
      const isExpanded = wrapper?.getAttribute('data-expanded') === 'true';
      wrapper?.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
    });

    row.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const wrapper = row.closest('.portfolio-row-wrapper');
        const isExpanded = wrapper?.getAttribute('data-expanded') === 'true';
        wrapper?.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
      }
    });
  });

  // Sector Filter Logic

  // Toggle dropdown
  sectorTrigger?.addEventListener('click', () => {
    sectorFilter?.classList.toggle('open');
    sectorDropdown?.classList.toggle('hidden');
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (!sectorFilter?.contains(e.target)) {
      sectorFilter?.classList.remove('open');
      sectorDropdown?.classList.add('hidden');
    }
  });

  // Handle option click (toggle selection)
  sectorOptions.forEach(option => {
    option.addEventListener('click', () => {
      const sector = option.getAttribute('data-sector');
      if (!sector) return;

      const checkIcon = option.querySelector('.sector-check');
      const index = selectedSectors.indexOf(sector);

      if (index > -1) {
        // Remove from array
        selectedSectors.splice(index, 1);
        checkIcon?.classList.add('hidden');
        option.classList.remove('selected');
      } else {
        // Add to array
        selectedSectors.push(sector);
        checkIcon?.classList.remove('hidden');
        option.classList.add('selected');
      }

      updateSectorUI();
      applyFilters();
    });
  });

  // Get display name for a sector (capitalize first letter)
  function getSectorDisplayName(sector) {
    // Find the option element to get the original display text
    const option = Array.from(sectorOptions).find(opt =>
      opt.getAttribute('data-sector') === sector
    );
    if (option) {
      const textEl = option.querySelector('span');
      return textEl?.textContent || sector;
    }
    return sector.charAt(0).toUpperCase() + sector.slice(1);
  }

  // Update button text, badge and clear button visibility
  function updateSectorUI() {
    const count = selectedSectors.length;
    const defaultText = sectorText?.getAttribute('data-default') || 'Select sector';

    if (count === 0) {
      // No selection - show default text, clear hidden (space reserved)
      if (sectorText) sectorText.textContent = defaultText;
      sectorBadge?.classList.add('hidden');
      sectorClear?.classList.add('hidden');
      sectorClear?.classList.remove('flex');
    } else if (count === 1) {
      // One selection - show sector name, no badge, clear flex
      if (sectorText) sectorText.textContent = getSectorDisplayName(selectedSectors[0]);
      sectorBadge?.classList.add('hidden');
      sectorClear?.classList.remove('hidden');
      sectorClear?.classList.add('flex');
    } else {
      // Multiple selections - show first sector name + badge, clear flex
      if (sectorText) sectorText.textContent = getSectorDisplayName(selectedSectors[0]);
      sectorBadge?.classList.remove('hidden');
      if (sectorBadge) sectorBadge.textContent = `+${count - 1}`;
      sectorClear?.classList.remove('hidden');
      sectorClear?.classList.add('flex');
    }
  }

  // Clear sector filter
  sectorClear?.addEventListener('click', (e) => {
    e.stopPropagation();
    selectedSectors = [];
    sectorOptions.forEach(option => {
      option.querySelector('.sector-check')?.classList.add('hidden');
      option.classList.remove('selected');
    });
    updateSectorUI();
    applyFilters();
  });

  // Apply button - close dropdown
  const sectorApply = document.getElementById('sector-filter-apply');
  sectorApply?.addEventListener('click', (e) => {
    e.stopPropagation();
    sectorFilter?.classList.remove('open');
    sectorDropdown?.classList.add('hidden');
  });
})();
